import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {AddressConverter} from '../../../../common/converter/address.converter';
import {LovValueSummaryConverter} from '../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {PartnerAddressModel} from '../model/partnerAddress.model';
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class PartnerAddressConverter extends HttpModelConverter<PartnerAddressModel> {

    constructor(private addressConverter: AddressConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): PartnerAddressModel {
        return new PartnerAddressModel();
    }

    protected enrichObject(result: PartnerAddressModel, src: PartnerAddressModel) {
        result.address = this.addressConverter.convert(src.address);
        result.type = this.lovValueSummaryConverter.convert(src.type);
    }
}
